import styled from "styled-components";
import {Divider, Typography} from "@mui/material";
import colors from "../../../../../../../../theme/colors";
import CloseIcon from '@mui/icons-material/Close';


export const DialogTitleContainer = styled.div`
    display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
`;

export const DialogTitle = styled(Typography)({
})

DialogTitle.defaultProps = {
    variant: 'subtitle2',
    color: colors.grayText
}


export const SignCanvasLineContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
    position: absolute;
  bottom: 20px;
  width: 100%;
  z-index: 100;
`;

export const SignSwitchContainer = styled.div`
    width: 100%;
  display: flex;
  flex-direction: column;
  margin: 16px 0 0 0;
`;

export const SwitchTitle = styled(Typography)({
})
SwitchTitle.defaultProps = {
    variant: 'body2',
    color: colors.grayText
}

export const SwitchDescTitle = styled(Typography)({
})
SwitchDescTitle.defaultProps = {
    variant: 'body2',
    color: colors.text.grey_dark
}

export const SignInputContainer = styled.div`
    width: 100%;
    height: 100px;
  background-color: ${colors.backgrounds.grey_light};
  position: relative;
`;

export const SignInput = styled.input`
  width: 80%;
  height: 24px;
  border: none;
  background-color: transparent;
  font-size: 24px;

  position: absolute;
  bottom: 20px;
  left: 8%;
  z-index: 200;
  
  &:focus-visible{
    outline: none;
  }
`;

export const SignDivider = styled(Divider)({
    width: '80%',
    color: colors.stroke.dark_grey
})

SignDivider.defaultProps = {
    flexItem: true
}

export const ClearButton = styled(CloseIcon)({
    color: colors.text.grey,
    cursor: 'pointer'
})